// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C_8cg","footer":"styles_footer__32UGh"};